import { Component } from '@angular/core';
import { ILoadingCellRendererAngularComp } from 'ag-grid-angular';
import { ILoadingCellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'pt-overlay-loading-renderer',
  template: `
    <div class="ag-custom-loading-cell loading-renderer text-muted">
      <div style="padding-left: 10px; line-height: 25px;">
        <div class="spinner-border spinner-border-sm" role="status"></div>
        <span> {{"MESSAGE.LOADING_DOTS" | translate}} </span>
      </div>
    </div>
  `,
  styles: [`
    .loading-renderer {
      width: 100vw;
      height: 100vh;
      display: flex;
      align-items: center;
      justify-content: center;
      /*background-color: white;*/
    }
  `]
})
export class OverlayLoadingRendererComponent implements ILoadingCellRendererAngularComp {

  public params: any;

  agInit(params: ILoadingCellRendererParams): void {
    this.params = params;
  }

}
